import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AgGridModule } from 'ag-grid-angular';

export interface EnvironmentServiceMappingDto {
  environment: string;
  services: string[];
}
@Component({
    standalone: true,
    selector: 'app-env-service-mapping',
    imports: [CommonModule, AgGridModule],
    templateUrl: './env-service-mapping.component.html',
    styleUrl: './env-service-mapping.component.scss'
})
export class EnvServiceMappingComponent implements OnInit {
  title = '';
  mappingdata: EnvironmentServiceMappingDto[] = [];
columnDefs = [
  { headerName: 'Environment', field: 'environment',flex: 1 },
  {
    headerName: 'Services',
    field: 'services',
    
    flex: 3,
    autoHeight: true,
    valueGetter: params => Array.isArray(params.data.services) ? params.data.services.join(', ') : params.data.services
  }
];

// Enable vertical scroll by setting grid height and domLayout
gridOptions = {
  domLayout: 'autoHeight'
};

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<any>,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.title = this.data ? this.data.title || '' : '';
    if (this.data?.popupcontent) {
      if (typeof this.data.popupcontent === 'string') {

        try {
          this.mappingdata = JSON.parse(this.data.popupcontent);
        } catch (e) {
          console.error('Invalid Environment and Service Mapping:', e);
        }
        this.cdr.detectChanges(); // Force update
      }
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
